import i18next from 'i18next';
import { CURRICULO_COLABORADOR, _URL_FORM, abrirFormCadastro, btnAcoesItensCurriculo, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';
import { uploadArquivo } from './uploads';

export const cursos = function () {
    "use strict";
    var _excluir = function (id) {
        swal({
            title: i18next.t('cursoRemoverTitle'),
            html: i18next.t('cursoRemoverDescricao'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show('#panel-curso');

            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteCurso?id=' + id, cache: false,
                success: function (data) {
                    if (data.success == 1) {
                        body.find('#curso-item-' + id).remove();
                        toastr.success(i18next.t('cursoRemoverSucesso'), '', { "closeButton": true });
                        progressoCurriculo();
                        _listar();
                    } else {
                        swal("", data.error, "error");
                    }
                    window.global.loaderPanel.hide('#panel-curso');
                },
                error: function () {
                    window.global.loaderPanel.hide('#panel-curso');
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };
    var _listar = function () {
        var panel = body.find('#panel-curso');
        window.global.loaderPanel.show('#panel-curso');

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetCursos', cache: false,

            success: function (dados) {
                var dadosLength = dados.length, html = [], item = '', horas = '', anoInicio = '';
                var elementNull = document.getElementById("curso-null");

                if (dadosLength > 0) {
                    elementNull.className = 'hide';
                    for (var i = 0; i < dadosLength; i++) {
                        horas = dados[i].CargaHoraria == '' ? '' : '<span class="text-muted">' + dados[i].CargaHoraria + ' ' + i18next.t('cursoHoras') + '</span> - ';
                        anoInicio = (dados[i].AnoInicio == '' || String(dados[i].AnoInicio) === '9999') ? '' : dados[i].AnoInicio + ' - ';
                        item = '<li class="list-group-item" id="curso-item-' + dados[i].ID + '" data-nome="' + dados[i].Nome + '" data-instituicao="' + dados[i].Instituicao + '" data-cargahoraria="' + dados[i].CargaHoraria + '" data-mes-inicio="' + dados[i].MesInicio + '" data-ano-inicio="' + dados[i].AnoInicio + '" data-certificado="' + dados[i].certificado + '">' + btnAcoesItensCurriculo(dados[i].ID);
                        item += '<h4 class="nomargin"><b>' + dados[i].Nome + '</b></h4>';
                        item += '<p>' + anoInicio + horas + dados[i].Instituicao + '</p>';
                        if (dados[i].AnoInicio == '' || String(dados[i].AnoInicio) === '9999') {
                            item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + dados[i].ID + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('cursoNomeNull') + ' </span></p>';
                        }
                        if (!isNullOrEmpty(dados[i].certificado)) {
                            item += '<p><a href="/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DownloadArquivo?arquivo=' + dados[i].certificado + '&nome=Certificado" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i> ' + i18next.t('downloadCertificado') + '</a></p>';
                        }
                        if (!isNullOrEmpty(dados[i].Descricao)) {
                            item += '<p class="hide curso-descricao">' + dados[i].Descricao + '</p>';
                        }

                        item += '</li>';
                        html.push(item);
                    }
                    document.getElementById('curso-lista').innerHTML = html.join('');
                    panel.find('.btn-excluir').on('click', function () {
                        var id = $(this).attr('data-id');
                        _excluir(id);
                    });
                    panel.find('.btn-editar').on('click', function () {
                        var id = $(this).attr('data-id');
                        _abrir(id);
                    });

                    panel.find('.btn-add').removeClass('hide');

                } else {
                    elementNull.className = '';
                }
                window.global.loaderPanel.hide('#panel-curso');

            },
            error: function () {
                window.global.loaderPanel.hide('#panel-curso');
            }
        });
    };
    var _salvar = function () {
        var content = body.find('#form-curso');

        var id = content.find('#curso-id').val();
        var nome = content.find('#curso-nome').val();
        var instituicao = content.find('#curso-instituicao').val();
        var descricao = content.find('#curso-descricao').val();
        var cargahoraria = content.find('#curso-cargahoraria').val();
        var mesInicio = content.find('#curso-mes-inicio').val();
        var anoInicio = content.find('#curso-ano-inicio').val();
        var anexoCertificado = content.find('#CursoAnexoCertificado').val();

        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveCurso', cache: false,
            data: {
                ID: id,
                Nome: nome,
                Instituicao: instituicao,
                Descricao: descricao,
                CargaHoraria: cargahoraria,
                mesInicio: mesInicio,
                anoInicio: anoInicio,
                AnexoCertificado: anexoCertificado
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('cursoSalvoSucesso'), '', { "closeButton": true });
                    if (id == 0) {
                        swal({
                            title: i18next.t('cursoSalvoOutroTitle'),
                            html: i18next.t('cursoSalvoOutroDesc'),
                            type: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#40afdf",
                            confirmButtonText: i18next.t('cursoSalvoOutroBtnAdd'),
                            cancelButtonText: i18next.t('btnNaoPossuo'),
                            closeOnConfirm: true
                        }, function (isConfirm) {
                            if (isConfirm) {
                                _abrir(0);
                            }
                        });
                    }

                    _listar();
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('curso-contentform').innerHTML = '';
        goToByScroll('#panel-curso');
        fecharFormCadastro();
    };
    var _abrir = function (id) {
        goToByScroll('#panel-curso');
        window.global.loaderFull.show();
        //window.global.loaderPanel.show('#panel-curso');
        var formulario = body.find('#curso-contentform');
        var dataCargo = {};
        var colaborador = CURRICULO_COLABORADOR();
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Curso?v=2", function () {
            $.validate({
                form: '#form-curso'
            });
            formulario.find('#curso-atividades').restrictLength($('#maxlengthAtividades'));
            formulario.find('#curso-resultados').restrictLength($('#maxlengthResultados'));
            if (colaborador) {
                formulario.find('.curso-upload').on('click', function (e) {
                    var $this = $(this);
                    uploadArquivo.abrir($this.attr('data-id'), $this.attr('data-titulo'));

                    e.preventDefault();
                });
            } else {
                formulario.find('#box-CursoAnexoCertificado').addClass('hide');
            }
            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-curso').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });
            if (id > 0) {
                var item = body.find('#curso-item-' + id);
                formulario.find('#title-box').html('<i class=\"fa fa-edit mr5\"></i> ' + i18next.t('cursoEditar'));
                formulario.find('#curso-nome').val(item.attr('data-nome'));
                formulario.find('#curso-instituicao').val(item.attr('data-instituicao'));
                formulario.find('#curso-descricao').val(item.find('.curso-descricao').html());
                formulario.find('#curso-cargahoraria').val(item.attr('data-cargahoraria'));
                formulario.find('#curso-ano-inicio').val(item.attr('data-ano-inicio'));


                if (!isNullOrEmpty(item.attr('data-certificado'))) {
                    uploadArquivo.templateArquivo('Certificado', item.attr('data-certificado'), 'CursoAnexoCertificado', false);
                }

                formulario.find('#curso-id').val(id);
            }
            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);

        });


    };

    var init = function () {
        _listar();

        body.find('#panel-curso').find('.btn-add').on('click', function (e) {
            _abrir(0);
            e.preventDefault();
        });
    }

    return init();
};

